import { LuBrainCircuit } from 'react-icons/lu';

import { useCopilot } from '../CopilotContext';
import { usePopoutVisibility } from '../popout/popoutChannel';

import styles from './CopilotLauncher.module.css';

/**
 * Top-bar entry point for the copilot — an icon-only, green-outlined button
 * (brain glyph) sitting next to the search bar that toggles the docked side
 * panel. Reads as "lit" when it's open.
 */
export function CopilotLauncher() {
  const { enabled, isOpen, toggle } = useCopilot();
  const popoutOpen = usePopoutVisibility();

  if (!enabled || popoutOpen) return null;

  return (
    <button
      type="button"
      className={`${styles.launcher} ${isOpen ? styles.active : ''}`}
      onClick={toggle}
      aria-label="ECHOGPT"
      aria-pressed={isOpen}
      title="ECHOGPT"
    >
      <LuBrainCircuit className={styles.icon} aria-hidden="true" />
    </button>
  );
}
